import React from 'react';
import { GlassContainer } from './GlassContainer';
import { TSizes } from '../constants/sizes';

export const ServiceCard = ({ service }) => {
  const { title, bio, media } = service || {};

  return (
    <GlassContainer
      radius={TSizes.radius2XL || 32}
      style={{
        width: '100%',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '200px',
          borderRadius: `${TSizes.radiusXL || 24}px`,
          overflow: 'hidden',
          backgroundColor: 'rgba(255, 255, 255, 0.02)'
        }}
      >
        {media?.url && (
          <img
            src={media.url}
            alt={title || ''}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        )}
      </div>

      <h3
        style={{
          margin: '16px 4px 0 4px',
          fontSize: '16px',
          fontWeight: '700',
          color: 'var(--text-primary)',
          textAlign: 'right',
          direction: 'rtl',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {title}
      </h3>

      <p
        style={{
          margin: '8px 4px 0 4px',
          fontSize: '14px',
          lineHeight: '1.45',
          fontWeight: '400',
          color: 'var(--text-secondary)',
          textAlign: 'right',
          direction: 'rtl',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {bio}
      </p>
    </GlassContainer>
  );
};
